<template>
  <wms-dual-auto-complate
    :span="span"
    :unFormIs="unFormIs"
    popper-class="my-autocomplete"
    :value-key="valueKey"
    :placeholder="placeholder"
    :prop="prop"
    :fuzzy-field="displayFuzzyField"
    :exact-field="displayExactField"
    :fuzzy-value.sync="form[formFuzzyField]"
    :exact-value.sync="form[formExactField]"
    :use-suggest="false"
    :fetch-suggestions="resolvedFetchSuggestions"
    @clear="handleClear"
    :valueKeys="valueKeys"
    :label="label"
    haveSlotScope
    v-bind="$attrs"
    v-on="listeners">
    <template slot-scope="scope">
      <template v-if="$slots.default">
        <slot v-bind="scope"></slot>
      </template>
      <template v-else>
        <div class="name">{{ scope.option.sku }}</div>
        <div class="addr">{{ scope.option.skuName }}</div>
      </template>
    </template>
  </wms-dual-auto-complate>
</template>

<script>
import { getSkuListApi } from '@/api/bas/sku'

export default {
  name: 'WmsDualSku',
  props: {
    form: { type: Object, required: true },
    unFormIs: { type: Boolean, default: false },
    visible: { type: Boolean, default: true },
    span: { type: Number, default: 6 },
    prop: { type: String, default: 'skuName' },
    label: { type: String, default: 'SKU' },
    fetchSuggestions: { type: Function, default: null },
    displayFuzzyField: { type: String, default: 'skuName' },
    displayExactField: { type: String, default: 'sku' },
    formFuzzyField: { type: String, default: 'skuName' },
    formExactField: { type: String, default: 'sku' },
    valueKey: { type: String, default: 'skuName' },
    valueKeys: { type: Array, default: () => ['sku', 'skuName'] },
    placeholder: { type: String, default: '' },
    extraParams: { type: Object, default: () => ({}) }
  },
  computed: {
    listeners() {
      const { clear, ...rest } = this.$listeners
      return rest
    },
    resolvedFetchSuggestions() {
      return this.fetchSuggestions || this.getSkuList
    }
  },
  methods: {
    handleClear(e) {
      document.activeElement && document.activeElement.blur()
      this.$emit('clear', e)
    },
    getSkuList(queryString, cb) {
      if (!queryString || queryString.trim() === '') {
        cb([])
        return
      }
      getSkuListApi({ skuName: queryString, ...this.extraParams }).then(res => {
        cb(res.data || [])
      }).catch(() => {
        cb([])
      })
    }
  }
}
</script>
